import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {Planning, PLANNING_METADATA} from 'smag-commons/dto/msg';
import {isDefined} from '../../commons/commons';
import {PLANNER_NAMES} from '../plannings';

@Component({
    selector: 'app-planning-details',
    templateUrl: './planning-details.component.html',
    styleUrls: ['./planning-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDetailsComponent implements OnInit {

    @Input() planning: Planning;

    constructor() {
    }

    ngOnInit() {
    }

    get planner(): string {
        return !!this.planning.metadata && !!this.planning.metadata[PLANNING_METADATA.PLANNER_KEY] ? this.planning.metadata[PLANNING_METADATA.PLANNER_KEY] : null;
    }

    get cost(): number {
        return !!this.planning.results && isDefined(this.planning.results.cost) ? this.planning.results.cost : null;
    }

    get sharedEnergy(): number {
        return !!this.planning.results && isDefined(this.planning.results.shared_energy) ? this.planning.results.shared_energy : null;
    }

    plannerName(plannerId: string): string {
        return PLANNER_NAMES[plannerId] || plannerId;
    }
}
